import styled from 'styled-components';
import { device } from 'theme/media';

export const Wrapper = styled.div`
  display: flex;
  width: inherit;
  height: 100%;
  flex-direction: column;
`;

export const SummaryWrapper = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: auto;

  @media ${device.mobile} {
    grid-template-columns: 1fr;
  }

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
  }
`;
